module.exports = __webpack_public_path__ + "static/media/b0_p7_melody.634efa2a.mp3";